// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import RoundedButton from "#/components/rounded_button/RoundedButton";
import ReadyToWork from "./ready_to_work/ReadyToWork";
import Countries from "./countries/Countries";
import Bodybuilder from "./bodybuilder/Bodybuilder";
import Branchen from "./branchen/Branchen";
import ModelSeries from "./model_series/ModelSeries";
import Solution from "./solution/Solution";
import Comparison from "./comparison/Comparison";
import ProductComparison from "./product_comparison/ProductComparison";

//Api
import { Api } from "#/api";
import { ProductFilterCountry } from "../../../common/interfaces/conversionworld/ProductFilter";
import { Iris } from "@mgs/ci2019-common/src/components/shared/iris/Iris";
@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    RoundedButton,
    ReadyToWork,
    Countries,
    Bodybuilder,
    Branchen,
    ModelSeries,
    Solution,
    Comparison,
    ProductComparison,
  },
})
export class FilterModule extends ModuleBase {
  @Prop({ default: true })
  public showFilter!: boolean;

  @Prop({ default: true })
  public showCompare!: boolean;

  @Prop({ default: false })
  public showReadyTab!: boolean;

  @Prop({ default: true })
  public showCountryTab!: boolean;

  @Prop({ default: true })
  public showBrancheTab!: boolean;

  @Prop({ default: true })
  public showSolutionTab!: boolean;

  @Prop({ default: true })
  public showModelTab!: boolean;

  @Prop({ default: true })
  public showBodybuilderTab!: boolean;

  @Prop({ default: false })
  public showAbhCount!: boolean;

  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  activeTab = "";

  openFilters = false;
  openComparison = false;
  openProductComparison = false;
  solutions: any[] = [];
  smallBtns = false;
  showAllBtn = false;
  showAll = false;
  resetBottom = false;
  headerElement;
  headerHeight = 185;
  pageYoffset = 0;
  prevBtnsWidth = 0;
  scrollinTicks = 0;

  private isSticky: boolean = false;

  showBar = true;
  comparisonMargin = false;
  windowSmall = false;

  get filterModuleFixed() {
    return this.$store.conversionWorld.filterModuleFixed;
  }

  get radioOptions() {
    return [
      {
        id: "both",
        text: this.instance["translation"]["allSolution"],
      },
      {
        id: "vansolution",
        text: this.instance["translation"]["onlyVanSolution"],
      },
      {
        id: "vanpartner",
        text: this.instance["translation"]["onlyVanPartner"],
      },
    ];
  }

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get radioOptionValue() {
    let value = this.filterStore.filter.type;

    return value ? value : "both";
  }

  private onRadioInput(value) {
    if (value === "both") {
      Vue.set(this.filterStore.filter, "type", undefined);
    } else {
      Vue.set(this.filterStore.filter, "type", value);
    }
  }

  get title() {
    if (this.$store.conversionWorld.vanSolutionProductsTotalCount > 0) {
      return (
        this.$store.conversionWorld.vanSolutionProductsTotalCount +
        " " +
        this.instance["translation"]["abh_search_van_solution"]
      );
    }

    return "";
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  async created() {
    this.filterStore.updateFilterData();
    !this.isMobile() && this.handleSelect("links", "countries", null);
  }

  beforeMount() {
    !this.isMobile() && this.setInitialActiveTab();
  }

  mounted() {
    this.headerElement = <HTMLElement>this.$refs["header"];
    this.handleScroll(undefined);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
    this.calcWidowWidth();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  }

  get solutionsCount() {
    let count = 0;
    if (this.filterStore.filterData) {
      this.filterStore.filterData.branchen.forEach((x) => {
        count += x.solutions.length;
      });
    }

    return count;
  }

  get filterTags() {
    return this.filterStore.filterTags;
  }

  get showFiltersCount() {
    return this.filterStore.filterTags.length > 0;
  }

  get showCompareProductsCount() {
    return this.$store.conversionWorld.compareProducts.length > 0;
  }

  get compareProducts() {
    return this.$store.conversionWorld.compareProducts;
  }

  get checkedFilters() {
    return this.filterStore.filterTags;
  }

  get readyTabLabel() {
    return this.instance["translation"]["headline_ready_to_work"];
  }

  get countryTabLabel() {
    return (
      this.instance["translation"]["headline_country"] +
      " (" +
      this.filterStore.countryFilterCount +
      ")"
    );
  }

  get brancheTabLabel() {
    return (
      this.instance["translation"]["headline_branche"] +
      " (" +
      this.filterStore.branchenFilterCount +
      ")"
    );
  }

  get solutionTabLabel() {
    return (
      this.instance["translation"]["headline_aufbauart"] +
      " (" +
      this.filterStore.solutionFilterCount +
      ")"
    );
  }

  get modelSeriesTabLabel() {
    return (
      this.instance["translation"]["headline_model"] +
      " (" +
      this.filterStore.modelSeriesFilterCount +
      ")"
    );
  }

  get bodybuilderTabLabel() {
    return (
      this.instance["translation"]["headline_abh"] +
      " (" +
      this.filterStore.bodybuilderFilterCount +
      ")"
    );
  }

  get count() {
    if (this.filterStore.filterData) {
      this.filterStore.filterData.count;
    }

    return 0;
  }

  private calcWidowWidth() {
    this.windowSmall = window.innerWidth < 1024 ? true : false;
  }

  private setInitialActiveTab() {
    if (this.showReadyTab) {
      this.activeTab = "ready";
    } else if (
      this.showCountryTab &&
      this.$store.page.page!.route_parameter.country === "GLOBAL"
    ) {
      this.activeTab = "countries";
    } else if (
      this.showBrancheTab &&
      !("branchenId" in this.$store.page.page!.route_parameter)
    ) {
      this.activeTab = "branchen";
    } else if (
      this.showSolutionTab &&
      !("einsatzzweckId" in this.$store.page.page!.route_parameter)
    ) {
      this.activeTab = "solution";
    } else if (this.showModelTab) {
      this.activeTab = "model_series";
    } else if (this.showBodybuilderTab) {
      this.activeTab = "bodybuilder";
    }
  }

  @Watch("openFilters")
  private openFiltersChange() {
    if (!this.openFilters) {
      window.scrollBy(0, this.pageYoffset);
    } else {
      Vue.nextTick(() => {
        this.calcHeaderSize();
      });
    }
  }

  @Watch("compareProducts")
  private compareProductsChange() {
    this.openComparison = true;
  }

  public handleShowFilter(show: boolean) {
    this.$store.ui.setShowFilter(show);
    if (show && window.pageYOffset) {
      this.pageYoffset = window.pageYOffset;
    }
    this.openFilters = show;

    if (show === false) {
      this.$eventBus.$emit("conversion-world-close-filter");
    }
  }

  public handleSelect(type, filterName, event) {
    if (event) event.preventDefault();
    if (type === "link" && this.activeTab === filterName) {
    } else if (type === "dropdown" && this.activeTab === filterName) {
      this.activeTab = "";
    } else {
      this.activeTab = filterName;
    }
  }

  public handleResize(event) {
    this.calcBtnsSize();
    this.calcHeaderSize();
    this.calcWidowWidth();
  }

  public handleShowAll() {
    this.showAll = !this.showAll;
  }

  public handleResetFilters() {
    this.filterStore.resetFilterTags();
    this.showAllBtn = false;
    this.smallBtns = false;
    this.resetBottom = false;
  }

  @Watch("showAll")
  onShowAllChange() {
    Vue.nextTick(() => {
      this.calcHeaderSize();
    });
  }

  @Watch("checkedFilters")
  onFiltersChanged() {
    Vue.nextTick(() => {
      this.calcBtnsSize();
      this.calcHeaderSize();
    });
  }

  private calcHeaderSize() {
    this.headerHeight = this.headerElement.getBoundingClientRect().height;
  }

  public handleScroll(e) {
    this.isSticky =
      (this.$el as HTMLElement).getBoundingClientRect().top ==
      this.$store.ui.bodyPadding;

    if (e && this.openComparison && this.scrollinTicks <= 3)
      this.scrollinTicks++;
    if (e && this.openComparison && this.scrollinTicks > 3) {
      this.openComparison = false;
      this.scrollinTicks = 0;
    }

    // if(this.filterModuleFixed && window.scrollY > 200) {
    //     this.showBar = true
    // } else if(this.filterModuleFixed && window.scrollY < 200) {
    //     this.showBar = false
    // }
  }

  public calcBtnsSize() {
    let selectedRow = <HTMLElement>this.$refs["selected"];
    let resetBtn = <HTMLElement>this.$refs["reset"];
    let children = <HTMLElement>selectedRow.children[0];

    let selectedWidth = selectedRow.getBoundingClientRect().width;
    let btnsWidth = children.getBoundingClientRect().width;
    let resetWidth = resetBtn.getBoundingClientRect().width;

    if (this.resetBottom) {
      this.smallBtns = true;
    }

    if (btnsWidth + 70 + resetWidth > selectedWidth && !this.smallBtns) {
      this.resetBottom = true;
      Vue.nextTick(() => {
        if (children.scrollHeight > 45) {
          this.smallBtns = true;
          this.prevBtnsWidth = btnsWidth;

          Vue.nextTick(() => {
            selectedWidth = selectedRow.getBoundingClientRect().width;
            btnsWidth = children.getBoundingClientRect().width;
            resetWidth = resetBtn.getBoundingClientRect().width;

            if (children.scrollHeight > 45) {
              this.showAllBtn = true;
              this.resetBottom = true;
            } else {
              this.showAllBtn = false;
              this.showAll = false;

              if (btnsWidth + 70 + resetWidth > selectedWidth) {
                this.resetBottom = true;
              } else {
                this.resetBottom = false;
              }
            }
          });
        }
      });
    } else if (this.smallBtns && this.resetBottom) {
      Vue.nextTick(() => {
        selectedWidth = selectedRow.getBoundingClientRect().width;
        btnsWidth = children.getBoundingClientRect().width;
        resetWidth = resetBtn.getBoundingClientRect().width;

        if (children.scrollHeight > 45) {
          this.showAllBtn = true;
          this.resetBottom = true;
        } else {
          this.showAllBtn = false;
          this.showAll = false;

          if (btnsWidth + 70 + resetWidth > selectedWidth) {
            this.resetBottom = true;
          } else {
            this.resetBottom = false;
          }
        }
      });
    } else if (this.smallBtns && !this.resetBottom) {
      if (btnsWidth < this.prevBtnsWidth) {
        this.smallBtns = false;
        Vue.nextTick(() => {
          this.calcBtnsSize();
        });
      } else {
        Vue.nextTick(() => {
          selectedWidth = selectedRow.getBoundingClientRect().width;
          btnsWidth = children.getBoundingClientRect().width;
          resetWidth = resetBtn.getBoundingClientRect().width;
          if (children.scrollHeight > 45) {
            this.showAllBtn = true;
            this.resetBottom = true;
          } else {
            this.showAllBtn = false;
            this.showAll = false;

            if (btnsWidth + 70 + resetWidth > selectedWidth) {
              this.resetBottom = true;
            } else {
              this.resetBottom = false;
            }
          }
        });
      }
    }
  }

  public handleShowComparison() {
    this.openComparison = !this.openComparison;
  }

  public handleProductCompare() {
    this.openProductComparison = !this.openProductComparison;
    this.$store.ui.setShowProductComparison(this.openProductComparison);
  }

  private isMobile() {
    return window.matchMedia("(max-width: 767px)").matches ? true : false;
  }
}
